import React, { MutableRefObject } from 'react';
import { Map } from 'mapbox-gl';
import { BottomMenu } from 'components/menu/BottomMenu';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useHistory } from 'react-router-dom';

interface FooterProps {
    mapRef: MutableRefObject<Map | null>;
}

export const Footer = ({ mapRef }: FooterProps) => {
    const history = useHistory();

    const handleHelpClick = () => {
        history.push('/welcome');
    };

    return (
        <>
            <BottomMenu mapRef={mapRef}/>
            <Box
                sx={{
                    position: 'relative',
                    height: '0',
                    overflow: 'visible',
                    p: 0,
                }}
            >
                <IconButton
                    aria-label='help'
                    onClick={handleHelpClick}
                    sx={{
                        position: 'absolute',
                        bottom: 16,
                        left: 16,
                        color: (theme) => theme.palette.primary.contrastText,
                    }}
                >
                    <HelpOutlineIcon sx={{ fontSize: '3rem' }}/>
                </IconButton>
            </Box>
        </>
    );
};
